import React from 'react';

const ConfirmDialog = ({ 
  show, 
  title, 
  message, 
  confirmText = "Löschen", 
  cancelText = "Abbrechen", 
  onConfirm, 
  onCancel,
  isDangerous = true 
}) => {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '1rem'
    }} onClick={onCancel}>
      <div style={{
        background: 'white', borderRadius: '12px', width: '100%',
        maxWidth: '400px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
      }} onClick={(e) => e.stopPropagation()}>
        
        {/* Header */}
        <div style={{
          padding: '1.5rem 1.5rem 1rem 1.5rem', 
          borderBottom: '1px solid #f1f5f9'
        }}>
          <div style={{
            width: '3rem', height: '3rem', borderRadius: '50%',
            background: isDangerous ? '#fef2f2' : '#eff6ff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 1rem auto'
          }}>
            <span style={{
              fontSize: '1.5rem',
              color: isDangerous ? '#ef4444' : '#3b82f6'
            }}>
              {isDangerous ? '⚠️' : 'ℹ️'}
            </span>
          </div>
          <h3 style={{
            color: '#1e293b', fontSize: '1.125rem', fontWeight: '600',
            textAlign: 'center', marginBottom: '0.5rem'
          }}>
            {title}
          </h3>
          <p style={{
            color: '#64748b', fontSize: '0.875rem', textAlign: 'center',
            lineHeight: '1.5'
          }}>
            {message}
          </p>
        </div>

        {/* Actions */}
        <div style={{
          display: 'flex', gap: '0.75rem', padding: '1.5rem',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onCancel}
            style={{
              background: 'white', color: '#64748b', 
              border: '1px solid #e2e8f0', padding: '0.75rem 1.5rem', 
              borderRadius: '8px', cursor: 'pointer', fontWeight: '500',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#f8fafc';
              e.target.style.borderColor = '#cbd5e1';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'white';
              e.target.style.borderColor = '#e2e8f0';
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: isDangerous ? '#ef4444' : '#3b82f6', 
              color: 'white', border: 'none', padding: '0.75rem 1.5rem',
              borderRadius: '8px', cursor: 'pointer', fontWeight: '500',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = isDangerous ? '#dc2626' : '#2563eb';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = isDangerous ? '#ef4444' : '#3b82f6';
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
